import { useGomakeTheme } from "@/hooks/use-gomake-thme";
import { HpSendIcon } from "@/themes/hp-client/icons";
import { useTheme } from "@/contexts/theme";

const SendIcon = (props: any) => {
  const { primaryColor } = useGomakeTheme();
  const strokeColor = props.color || primaryColor(300);
  const { currentTheme } = useTheme();
  if (currentTheme === "hp-client") {
    return (
      <HpSendIcon
        color={props?.color ?? "#1A1A1A"}
        width={props?.width ?? 24}
        height={props?.height ?? 24}
      />
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width ?? 16}
      height={props?.height ?? 16}
      viewBox="0 0 24 24"
      fill="none"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-send-icon lucide-send"
    >
      <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" />
      <path d="m21.854 2.147-10.94 10.939" />
    </svg>
  );
};

export { SendIcon };
